<script setup lang="ts">
import { NRadio } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  value?: any
  label?: string
  disabled?: boolean
  size?: 'small' | 'medium' | 'large'
  checked?: boolean
  name?: string
  focusable?: boolean
  tabindex?: number
}>(), {
  value: undefined,
  label: undefined,
  disabled: false,
  size: 'medium',
  checked: false,
  name: undefined,
  focusable: true,
  tabindex: undefined,
})

const emit = defineEmits<{
  'update:checked': [checked: boolean]
  'change': [checked: boolean, value: any]
  'focus': [e: FocusEvent]
  'blur': [e: FocusEvent]
}>()

const attrs = useAttrs()

const onUpdateChecked = (checked: boolean) => {
  emit('update:checked', checked)
}

const onChange = (checked: boolean) => {
  emit('change', checked, props.value)
}

const onFocus = (e: FocusEvent) => {
  emit('focus', e)
}

const onBlur = (e: FocusEvent) => {
  emit('blur', e)
}
</script>

<template>
  <NRadio
    :value="value"
    :label="label"
    :disabled="disabled"
    :size="size"
    :checked="checked"
    :name="name"
    :focusable="focusable"
    :tabindex="tabindex"
    v-bind="attrs"
    @update:checked="onUpdateChecked"
    @change="onChange"
    @focus="onFocus"
    @blur="onBlur"
  >
    <template #default>
      <slot />
    </template>
  </NRadio>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
